import { z } from 'zod'
import { paginationLinksSchema, paginationMetaSchema } from './pagination'

export const smsGlobalSchema = z.object({
    uuid: z.string().uuid(),
    title: z.string(),
    name: z.string(),
    origin: z.string(),
    api_key: z.string(),
    api_secret: z.string(),
    api_url: z.string(),
    db_driver: z.string(),
    db_host: z.string(),
    db_name: z.string(),
    db_username: z.string(),
    db_password: z.string(),
    db_port: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
    deleted_at: z.string().nullable(),
    description: z.string().nullable(),
})

export const smsGlobalsSchema = z.array(smsGlobalSchema)

export const paginatedSMSGlobalServersSchema = z.object({
    data: smsGlobalsSchema,
    links: paginationLinksSchema.nullish(),
    meta: paginationMetaSchema.nullish(),
})

const validation_requiredMessage = "You can't leave this empty."

export const smsGlobalServerFormSchema = z.object({
    title: z.string().min(1, {
        message: validation_requiredMessage,
    }),
    description: z.string().nullish(),
})

export type SMSGlobalServerForm = z.infer<typeof smsGlobalServerFormSchema>
